<template>
	<div class="c-message" v-if="!isClosed" :class="'c-message--' + type" ref="message">
		<div class="o-width-limiter">
			<div class="c-message__content">
				<p>
					<strong v-if="title !== ''">{{title}}: </strong><span v-html="decodeURIComponent(message)"></span> <a v-if="readMore.url" class="c-message__read-more" :href="readMore.url">{{readMore.text}}</a>
				</p>
				<button @click="closeMessage()" v-if="closable" class="c-message__close" type="button">
					<span class="t-visually-hidden">Stäng meddelande</span>
					<v-icon name="icon-close-bold" size="xs" cssModifiers="c-message__close-icon"></v-icon>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import VIcon from '../../components/icon/VIcon.vue';

export default {
    name: 'VMessage',
	components: {
		VIcon
	},
	props: {
		id: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'neutral'
		},
		closable: {
			type: Boolean,
			default: false
		},
		cookie: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: 'Meddelandetext'
		},
		readMore: {
			type: Array,
			default: () => []
		},
		storybook: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			isClosed: false
		}
	},
	methods: {
		closeMessage () {
			if (!this.storybook) {
				this.$destroy();
				this.$el.remove();
	
				this.$cookies.set(this.cookie.key, this.cookie.value, this.cookie.expire);
			}
		}
	},
	created() {
		if (!this.storybook && this.$cookies.get(this.cookie.key) === this.cookie.value) {
			this.isClosed = true;
		}
	}
}
</script>
